import Media from '../../api/media'
import {
  SET_SHOW_UPLOAD_FILE_MODAL,
  SET_IS_LOADING_FILE_LIST,
  SET_FILE_LIST_INFO,
  SET_FILE_QUERY,
} from '../mutation-types'

const file = {
  namespaced: true,
  state: {
    files: [{ key: -1 }, { key: -2 }], // initial loading placeholders
    fileQuery: {
      page: 1,
      size: 50,
      sizes: [50, 100, 200],
      total: 0,
    },
    isLoadingFiles: false,
    showFileUploadModal: false,
  },
  getters: {
    files: state => state.files,
    fileQuery: state => state.fileQuery,
    isLoadingFiles: state => state.isLoadingFiles,
    isShowFileUploadModal: state => state.showFileUploadModal,
  },
  actions: {
    setShowFileUploadModal({ commit }, show) {
      commit(SET_SHOW_UPLOAD_FILE_MODAL, show)
    },
    setSizeQuery({ getters, commit, dispatch }, size) {
      commit(SET_FILE_QUERY, { ...getters.fileQuery, size })
      dispatch('getFileList')
    },
    setPageQuery({ getters, commit, dispatch }, page) {
      if (getters.fileQuery.page === page) {
        return
      }
      commit(SET_FILE_QUERY, { ...getters.fileQuery, page })
      dispatch('getFileList')
    },
    async getFileList({ getters, commit }) {
      commit(SET_IS_LOADING_FILE_LIST, true)
      try {
        const response = await Media.getList(getters.fileQuery.page, getters.fileQuery.size)
        const newList = response.data
        const {
          total_items: totalItems,
        } = response.pagination

        commit(SET_FILE_LIST_INFO, {
          fileList: newList,
          totalItems: parseInt(totalItems, 0),
        })
      } catch (error) {
        console.log(error)
      } finally {
        commit(SET_IS_LOADING_FILE_LIST, false)
      }
    },
  },
  mutations: {
    [SET_SHOW_UPLOAD_FILE_MODAL]: (state, show) => {
      state.showFileUploadModal = show
    },
    [SET_FILE_QUERY]: (state, query) => {
      state.fileQuery = query
    },
    [SET_IS_LOADING_FILE_LIST]: (state, isLoading) => {
      state.isLoadingFiles = isLoading
    },
    [SET_FILE_LIST_INFO]: (state, { fileList, totalItems }) => {
      state.files = fileList
      state.fileQuery.total = totalItems
    },
  },
}

export default file
